
import topicsDir from "../__topicsDir";


/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2024-10-28T09:00",
		title: `
<h4></h4>
<p class="paragraph-indent">
●令和6年10月18日に、かかりつけ医機能報告制度に係る第１回自治体向け説明会が行われました。<br>
・<a href="${topicsDir}/2024/10_1st_kakarituke_session.pdf">説明資料全体</a><br>
・<a href="${topicsDir}/2024/10_kakarituke_schedule.pdf">制度の運用スケジュール</a><br><br>

<a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000123022_00007.html">厚労省「かかりつけ医機能報告制度」に関するサイト</a><br>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
